import { render, staticRenderFns } from "./GetPurchaseInvoiceHeaders.vue?vue&type=template&id=169afad8&scoped=true&"
import script from "./GetPurchaseInvoiceHeaders.vue?vue&type=script&lang=js&"
export * from "./GetPurchaseInvoiceHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169afad8",
  null
  
)

export default component.exports